import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <div className="relative">
              <span className="absolute -top-3 -left-3 px-4 py-1.5 rounded-full border border-secondary-300 bg-background-50 text-secondary-700 text-xs font-medium tracking-wide z-10">
                Über OOPBUY Spreadsheet
              </span>
              <div className="rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Lifestyle%20flatlay%20of%20carefully%20curated%20fashion%20pieces%20arranged%20on%20a%20light%20textured%20linen%20surface%2C%20a%20sage%20green%20hoodie%20neatly%20folded%2C%20white%20leather%20sneakers%20with%20subtle%20green%20detailing%2C%20a%20minimalist%20watch%20with%20tan%20leather%20strap%2C%20delicate%20gold%20necklace%20draped%20casually%2C%20a%20steaming%20white%20ceramic%20mug%2C%20soft%20warm%20natural%20daylight%20from%20a%20large%20window%2C%20cozy%20Scandinavian%20interior%20aesthetic%2C%20clean%20editorial%20composition%2C%20warm%20neutral%20tones%20with%20olive%20accents&width=800&height=1000&seq=about-v2-01&orientation=portrait"
                  alt="OOPBUY Spreadsheet Lifestyle"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-bold leading-tight">
              Was ist das OOPBUY Spreadsheet?
            </h2>
            <p className="mt-5 text-foreground-600 text-base leading-relaxed">
              Das OOPBUY Spreadsheet ist Ihr unverzichtbares Werkzeug für den cleveren Einkauf 
              über chinesische Shopping-Plattformen. Es vereint sorgfältig kuratierte Produktlisten, 
              geprüfte Verkäufer, detaillierte QC-Bewertungen und aktuelle Versandinformationen – 
              alles in einem übersichtlichen Format.
            </p>
            <p className="mt-4 text-foreground-600 text-base leading-relaxed">
              Unser Guide hilft Ihnen, die besten Deals auf Plattformen wie Taobao, Weidian 
              und 1688 zu finden. Ob Sneaker, Hoodies, T-Shirts oder Accessoires – mit dem 
              OOPBUY Spreadsheet sparen Sie Zeit und Geld.
            </p>

            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="text-foreground-900 text-sm font-semibold">Geprüfte Verkäufer</h4>
                  <p className="text-foreground-500 text-xs mt-0.5">Nur vertrauenswürdige Shops</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="text-foreground-900 text-sm font-semibold">QC Bewertungen</h4>
                  <p className="text-foreground-500 text-xs mt-0.5">Qualitätskontrolle inklusive</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="text-foreground-900 text-sm font-semibold">Versandinfos</h4>
                  <p className="text-foreground-500 text-xs mt-0.5">Aktuelle Lieferzeiten & Kosten</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="text-foreground-900 text-sm font-semibold">Kostenlos</h4>
                  <p className="text-foreground-500 text-xs mt-0.5">100% gratis für alle Nutzer</p>
                </div>
              </div>
            </div>

            <Link
              to="/artikel/oopbuy-spreadsheet-guide"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap"
            >
              Zum vollständigen Guide
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}